module.exports = __webpack_public_path__ + "9b7ee280abc3d05e4de70dfe4bbb5f54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/galeriaFotos/002.jpg
// module id = 56
// module chunks = 0